import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <section
      className="section"
      style={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <div>
        <p style={{ fontSize: "6rem", fontWeight: 700, color: "var(--accent)", lineHeight: 1 }}>404</p>
        <h1 style={{ color: "var(--text-primary)", fontSize: "1.75rem", margin: "1rem 0 0.75rem" }}>
          Page Not Found
        </h1>
        <p style={{ color: "var(--text-muted)", marginBottom: "2rem" }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="btn btn-primary">
          ← Back to Home
        </Link>
      </div>
    </section>
  );
};

export default NotFound;
